/**
 * @generated SignedSource<<9169b87c8ee17bd19dfef9c638876cfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ResyncCalendarAsyncTaskQuery$variables = {
  taskId: any;
};
export type ResyncCalendarAsyncTaskQuery$data = {
  readonly viewer: {
    readonly asyncTask: {
      readonly info: any;
      readonly state: string;
      readonly taskId: any;
    } | null;
  };
};
export type ResyncCalendarAsyncTaskQuery = {
  response: ResyncCalendarAsyncTaskQuery$data;
  variables: ResyncCalendarAsyncTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "ignoreChildren",
      "value": true
    },
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    }
  ],
  "concreteType": "AsyncTask",
  "kind": "LinkedField",
  "name": "asyncTask",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResyncCalendarAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResyncCalendarAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f2443f17cbd1df07dc759c4cadba6ab",
    "id": null,
    "metadata": {},
    "name": "ResyncCalendarAsyncTaskQuery",
    "operationKind": "query",
    "text": "query ResyncCalendarAsyncTaskQuery(\n  $taskId: JSON!\n) {\n  viewer {\n    asyncTask(taskId: $taskId, ignoreChildren: true) {\n      taskId\n      state\n      info\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3d75528350c65f359df9c7d91cce045";

export default node;
